import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CUSTODIAN_ROLES, LENDER_ADMIN_ROLES, LENDER_ROLES } from '../constants/iam-roles.constants';

/**
 * externalLandingGuard — redirects IC1_MFRM* external users from the root path to
 * their landing page.
 *
 * Run this AFTER authGuard so authentication is already confirmed.
 *
 * - If the user holds IC1_MFRM_CUSTODIAN_ROLE (even together with a lender role),
 *   redirect to /custodian/reserve-requirement-summary.
 * - Else if the user holds IC1_MFRM_LENDER_ROLE or IC1_MFRM_LENDER_ADMIN_ROLE,
 *   redirect to /lender-overview/external-lenders.
 * - Otherwise return true to allow the internal landing page to load.
 */
export const externalLandingGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasRole(...CUSTODIAN_ROLES)) {
    await router.navigate(['/custodian/reserve-requirement-summary']);
    return false;
  }

  if (authService.hasRole(...LENDER_ROLES, ...LENDER_ADMIN_ROLES)) {
    await router.navigate(['/lender-overview/external-lenders']);
    return false;
  }

  return true;
};
